import { useState } from "react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";
import { Mail, Phone, MapPin, Clock, Loader2 } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitContact(form);
      toast.success("Message sent — we'll be in touch soon.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="bg-[#FDFBF7] border-b border-black/10">
        <div className="container-x py-20 md:py-28">
          <span className="overline text-[#6B21A8]">Contact</span>
          <h1 className="mt-4 font-display text-5xl md:text-7xl font-bold tracking-tight leading-none">Let's build<br /><span className="italic">something together.</span></h1>
        </div>
      </section>

      <section className="bg-white">
        <div className="container-x py-16 md:py-20 grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5 space-y-8">
            <div>
              <p className="overline text-[#6B21A8] mb-4">Reach us</p>
              <ul className="space-y-4 text-black/80">
                <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-[#6B21A8] mt-0.5" /> Clayton County, Georgia</li>
                <li className="flex items-start gap-3"><Mail className="h-5 w-5 text-[#6B21A8] mt-0.5" /> <a href="mailto:change@changecentermentoring.com" className="hover:text-[#6B21A8]">change@changecentermentoring.com</a></li>
                <li className="flex items-start gap-3"><Phone className="h-5 w-5 text-[#6B21A8] mt-0.5" /> <a href="tel:+14043260944" className="hover:text-[#6B21A8]">(404) 326-0944</a></li>
                <li className="flex items-start gap-3"><Clock className="h-5 w-5 text-[#6B21A8] mt-0.5" /> Mon–Fri · 9am–6pm ET</li>
              </ul>
            </div>
            <div className="border border-black/10">
              <iframe
                title="Location map"
                src="https://www.google.com/maps?q=Forest+Park,+GA&output=embed"
                className="w-full h-72 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="md:col-span-7">
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <div className="grid gap-4 sm:grid-cols-2">
                <input required placeholder="Full name" value={form.name} onChange={set("name")} data-testid="contact-name" className="rounded-md border border-black/15 bg-white px-4 py-3 outline-none focus:border-[#6B21A8]" />
                <input type="email" required placeholder="Email" value={form.email} onChange={set("email")} data-testid="contact-email" className="rounded-md border border-black/15 bg-white px-4 py-3 outline-none focus:border-[#6B21A8]" />
              </div>
              <div className="grid gap-4 sm:grid-cols-2">
                <input placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} data-testid="contact-phone" className="rounded-md border border-black/15 bg-white px-4 py-3 outline-none focus:border-[#6B21A8]" />
                <input placeholder="Subject" value={form.subject} onChange={set("subject")} data-testid="contact-subject" className="rounded-md border border-black/15 bg-white px-4 py-3 outline-none focus:border-[#6B21A8]" />
              </div>
              <textarea required rows="6" placeholder="Tell us how we can help…" value={form.message} onChange={set("message")} data-testid="contact-message" className="w-full rounded-md border border-black/15 bg-white px-4 py-3 outline-none focus:border-[#6B21A8]" />
              <button type="submit" disabled={loading} data-testid="contact-submit" className="btn-primary">
                {loading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Sending…</>) : "Send message"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}
